/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React__default from 'react';
import { useFeatureFlag } from '../FeatureFlags/index.js';
import { OverflowMenu as OverflowMenu$2 } from './next/index.js';
import { OverflowMenu as OverflowMenu$1 } from './OverflowMenu.js';
import { createClassWrapper } from '../../internal/createClassWrapper.js';

const OverflowMenuV11 = createClassWrapper(OverflowMenu$1);
function OverflowMenu(props) {
  const enableV12OverflowMenu = useFeatureFlag('enable-v12-overflowmenu');
  return enableV12OverflowMenu ? /*#__PURE__*/React__default.createElement(OverflowMenu$2, props) : /*#__PURE__*/React__default.createElement(OverflowMenuV11, props);
}
OverflowMenu.displayName = 'OverflowMenu';

export { OverflowMenu, OverflowMenu as default };
